import { TYPES as ICON_TYPES } from '../../icon/constants';
import { APPEARANCES as ACTION_BUTTON_APPEARANCES } from '../../action-button/constants';
import { APPEARANCES as TEXT_APPEARANCES } from '../../text/constants';
import { APPEARANCES } from '../constants';

const getAppearanceConfig = (appearance) => {
  switch (appearance) {
    case APPEARANCES.default: {
      return {
        iconType: ICON_TYPES.default,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
        titleAppearance: TEXT_APPEARANCES.highEmphasis,
      };
    }

    case APPEARANCES.accent: {
      return {
        iconType: ICON_TYPES.accent,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.accent,
        titleAppearance: TEXT_APPEARANCES.accent,
      };
    }

    case APPEARANCES.cta: {
      return {
        iconType: ICON_TYPES.cta,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.cta,
        titleAppearance: TEXT_APPEARANCES.cta,
      };
    }

    case APPEARANCES.danger: {
      return {
        iconType: ICON_TYPES.error,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.danger,
        titleAppearance: TEXT_APPEARANCES.danger,
      };
    }

    case APPEARANCES.success: {
      return {
        iconType: ICON_TYPES.success,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
        titleAppearance: TEXT_APPEARANCES.success,
      };
    }

    case APPEARANCES.warning: {
      return {
        iconType: ICON_TYPES.warning,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
        titleAppearance: TEXT_APPEARANCES.warning,
      };
    }

    case APPEARANCES.info: {
      return {
        iconType: ICON_TYPES.inherit,
        actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
        titleAppearance: TEXT_APPEARANCES.inherit,
      };
    }
  }

  return {
    iconType: ICON_TYPES.accent,
    actionButtonAppearance: ACTION_BUTTON_APPEARANCES.default,
    titleAppearance: TEXT_APPEARANCES.highEmphasis,
  };
};

export default getAppearanceConfig;
